import { getField, updateField } from 'vuex-map-fields';
import StorageService from '@/services/StorageService';
import CoursesService from '@/services/CoursesService';

const getDefaultState = function () {
    return {
        id: null,
        name: null,
        accessForDisabled: null,
        address: null,
        airConditioningControl: null,
        cafeteria: null,
        capacity: null,
        capacityYellowLine: null,
        city: null,
        computer: null,
        contactInfo: null,
        courseId: null,
        editorNode: null,
        googleMapLink: null,
        lecturesRegionsId: null,
        lecturesRegionName: null,
        openFrom: null,
        openUntil: null,
        parkingForStudents: null,
        parkingForTeacher: null,
        projector: null,
        refreshments: null,
        soundSystem: null,
        status: null,
        tablesTypes: null,
        userNote: null,
        wazelink: null,
        whiteboard: null
    };
};

/* eslint no-shadow: ["error", { "allow": ["state"] }] */
const state = getDefaultState();

const getters = {
    getField,
    form: (state) => ({
        id: state.id,
        name: state.name,
        accessForDisabled: state.accessForDisabled,
        address: state.address,
        airConditioningControl: state.airConditioningControl,
        cafeteria: state.cafeteria,
        capacity: state.capacity,
        capacityYellowLine: state.capacityYellowLine,
        city: state.city,
        computer: state.computer,
        contactInfo: state.contactInfo,
        courseId: state.courseId,
        editorNode: state.editorNode,
        googleMapLink: state.googleMapLink,
        lecturesRegionsId: state.lecturesRegionsId,
        lecturesRegionName: state.lecturesRegionName,
        openFrom: state.openFrom,
        openUntil: state.openUntil,
        parkingForStudents: state.parkingForStudents,
        parkingForTeacher: state.parkingForTeacher,
        projector: state.projector,
        refreshments: state.refreshments,
        soundSystem: state.soundSystem,
        status: state.status,
        tablesTypes: state.tablesTypes,
        userNote: state.userNote,
        wazelink: state.wazelink,
        whiteboard: state.whiteboard
    }),
};

const mutations = {
    setLecturesHall(state, value) {
        if (value) {
            // value.Transfers.forEach((status) => {
            //     status.Events.sort((a, b) => new Date(a.Date) - new Date(b.Date));
            // });
            Object.assign(state, value);
        } else {
            Object.assign(state, getDefaultState());
        }
    },

    storeReportDetails(state, data) {
        Object.assign(state, data);
    },
    updateField,
};

const actions = {
    async loadLecturesHall({ commit }, data) {
        const course = StorageService.getCourse();
        const res = await CoursesService.getCourseHalls(course.id, {
            EntityId: data.id
        });
        commit('setLecturesHall', res.data.items[0]);
        return res.data;
    },
    async loadLecturesHallAdmin({ commit }, data) {
        const res = await CoursesService.getReportAdmin(data.id);
        commit('setLecturesHall', res.data);
        return res.data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
